import * as React from "react";
import { Component, CSSProperties } from "react";
import { Alert, AlertTitle, Snackbar, Button } from "@mui/material";

interface V3ReleaseNotificationProps {
    isVisible: boolean;
    onLearnMore?: () => void;
    onInstall?: () => void;
}

const alertStyle: CSSProperties = {
    minWidth: "400px",
    maxWidth: "500px"
};

export default class V3ReleaseNotification extends Component<V3ReleaseNotificationProps> {
    render() {
        const { isVisible, onLearnMore, onInstall } = this.props;

        const handleInstall = () => {
            if (onInstall) {
                onInstall();
            }
        };

        return (
            <Snackbar
                open={isVisible}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={null}
            >
                <Alert
                    severity="info"
                    style={alertStyle}
                >
                    <AlertTitle>iDART Background Service Required</AlertTitle>
                    <div>
                        As your account has HDC V3 devices, the iDART Background Service needs to be installed
                        for automatic data collection.
                    </div>
                    <div style={{ marginTop: "8px", fontSize: "0.9em" }}>
                        <strong>What to expect:</strong>
                        <ul style={{ margin: "4px 0", paddingLeft: "20px" }}>
                            <li>Clicking &quot;Yes, Install&quot; will prompt you to approve administrator access (UAC)</li>
                            <li>Installation may take 10+ minutes if SQL Express is required</li>
                            <li>Installation runs in the background - you can continue to view data and use HDC V2s and RDCs as usual</li>
                        </ul>
                    </div>
                    <div style={{ marginTop: "12px", display: "flex", justifyContent: "center", gap: "8px" }}>
                        {onLearnMore ? (
                            <Button color="inherit" size="small" onClick={onLearnMore}>
                                Learn More
                            </Button>
                        ) : null}
                        {onInstall ? (
                            <Button variant="contained" color="primary" size="small" onClick={handleInstall}>
                                Yes, Install
                            </Button>
                        ) : null}
                    </div>
                </Alert>
            </Snackbar>
        );
    }
}
